import { apolloClient } from "@/plugins/vue-apollo.js";

const createVerifiedLandlord = (_variables) => {
  // , limit, skip
  let responseFromApi;
  let variables = _variables;

  responseFromApi = apolloClient
    .mutate({
      mutation: require("@/landlord/api/mutations/create_landlord_admin.graphql"),
      variables: variables,
      update: (store, { data }) => {
        const query = {
          query: require("@/landlord/api/queries/landlord_query.graphql"),
          variables: {
            input: {
              limit: 10,
              skip: 0
            },
            filter: {
              searchKey: '',
              sortBy: ''
            }
          }
        };
        let allLandlord = store.readQuery(query);
        allLandlord.getLandlords.landlords.unshift(data.createLandlord); //push to top
        store.writeQuery({
          ...query,
            data: allLandlord,
        });
      }
    })
    .catch(error => {
      return error;
    });
  return responseFromApi;
};
export { createVerifiedLandlord };
